<div class="d-flex flex-column justify-content-center">
  <div class="delete_bill_text"> {{ (orderBillToDelete ? 'ORDER_BILL.DELETE_BILL_TEXT' : 'ORDER_BILL.DELETE_BILL_ITEM_TEXT') | translate}}</div>
  <div class="d-flex flex-row justify-content-end">
    <button class="delete_btn" (click)="delete()">{{'DELETE' | translate | uppercase}}</button>
    <button class="cancel_delete_btn" (click)="cancel()">{{'CANCEL' | translate | uppercase}}</button>
  </div>
</div>
